export default function WipeTransition() {
  return (
    <div className="assess-wipe">
      <div className="assess-wipe-msg">
        <div style={{ fontSize: 20, color: "rgba(255,255,255,0.85)", fontWeight: 600, letterSpacing: 1, marginBottom: 10 }}>
          Next Up...
        </div>
        <div className="assess-bar"><i /></div>
      </div>
    </div>
  );
}
